/** Mirrors the API's media rows (apps/api/src/repositories/media.repository.ts). Kept local
 * to apps/web rather than in packages/shared — this is a read shape, not a validated schema. */
export interface MediaVariant {
  id: number;
  format: 'avif' | 'webp' | 'jpeg' | 'png' | 'gif' | 'svg';
  width: number;
  height: number;
  storagePath: string;
}

export interface MediaItem {
  id: number;
  type: 'image' | 'video' | 'document' | 'audio';
  storagePath: string;
  originalFilename: string;
  mimeType: string;
  width: number | null;
  height: number | null;
  altTextAs: string | null;
  altTextEn: string | null;
  captionAs: string | null;
  captionEn: string | null;
  credit: string | null;
  blurhash: string | null;
  variants: MediaVariant[];
}

/** `storagePath` is relative to `MEDIA_ROOT/public`, served at `/media/*` (§1.9/§1.11). */
export function mediaUrl(storagePath: string): string {
  return `/media/${storagePath}`;
}
